import Navigo from "navigo";

import * as model from './model';
import servicesView from "./views/servicesView";
import serviceView from "./views/serviceView";
import registerView from "./views/registerView";

import backgroundImage from 'url:../img/background.png'
import {SERVICE_TYPES} from "./helpers";

const router = new Navigo('/');

///////////////////////////////////////
const controlRouting = function () {

    router.on('/', function () {
        controlServices();
    });

    router.on('/apliko/:id',  function (match) {
        const {id} = match.data;
        controlService(+id);
    });

    router.resolve();
};

const controlServices = function () {
    servicesView.render(model.state.services);
    servicesView.addHandlerScrollAnimation();
    servicesView.addHandlerService(controlService);
};

const controlService = function (serviceId) {

    if (!serviceId) return;

    // 1. Get and set current clicked service
    model.state.service = model.state.services.find(service => service.id === serviceId);

    servicesView.addHandlerService();

    // 2. Get and set all universities, which will be used to populate the select
    model.loadUniversities();

    // Guard clause, because a manual is only a PDF document we don't have to render anything
    if (model.state.service.type === SERVICE_TYPES.manual) return;

    serviceView.render(model.state.service);
    registerView.selectDOMElements();
    registerView.addHandleSelectUniversity(controlFaculties);

    registerView.addHandlerForm(controlSendEmail);
};

const controlFaculties = function(id) {
    model.loadFaculties(id);
    registerView.generateMarkupSelectFaculties(model.state.service.faculties);
    registerView.addHandlerSelectFaculty(controlFaculty);
};

const controlFaculty = function(id) {
    model.loadFaculty(id);
    registerView.updateMarkupInputEmail(model.state.service.faculty);
};

const controlSendEmail = function(emailData) {

    registerView.renderSpinner(undefined, 'register--logo');

    model.loadUniversity(+emailData.universities);
    model.loadFaculty(+emailData.faculties);

    const markup = `
            <!DOCTYPE html>
            <html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office">
            <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width,initial-scale=1">
                <meta name="x-apple-disable-message-reformatting">
                <title></title>
                <!--[if mso]>
                <noscript>
                    <xml>
                        <o:OfficeDocumentSettings>
                            <o:PixelsPerInch>96</o:PixelsPerInch>
                        </o:OfficeDocumentSettings>
                    </xml>
                </noscript>
                <![endif]-->
                <style>
                    table, td, div, h1, p {
                        font-family: Arial, sans-serif;
                    }
                </style>
            </head>
            <body style="margin: 0; padding: 0">
            <table role="presentation"
                   style="width: 100%; border-collapse: collapse; border: 0; border-spacing: 0; background: #ffffff">
                <tr>
                    <td align="center" style="padding: 0; margin: 0 auto;">
                        <table role="presentation"
                               style="width: 602px; border-collapse: collapse; border: 0; border-spacing: 0; text-align:left;">
                            <tr>
                                <td align="center" style="padding:40px 0 30px 0;background:#eeeced;">
                                    <img src="https://www.rash.al/media/filer_public/d5/0c/d50cc2e4-d2c9-432f-a937-14667a34c8dc/rash-logo-horizontal.png"
                                         alt="Rrjeti Akademik Shqiptar Logo"
                                         width="300"
                                         style="height:auto;display:block;"/>
                                </td>
                            </tr>
                            <tr style="background: #f7f5f4">
                                <td style="padding:36px 30px 42px 30px; background: #f7f5f4">
                                    <table role="presentation" style="width: 100%; border-collapse: collapse; border: 0; border-spacing: 0;">
                                        <tr>
                                            <td style="padding:0;">
                                                <h2 style="font-size: 24px; line-height: 40px; margin-bottom: 40px;">
                                                    Kërkesë që të hapet llogari për shërbimin:
                                                    <span style="text-transform: uppercase">${model.state.service.name}</span>
                                                </h2>
                                                <h3 style="font-size: 20px; font-weight: 400; margin-bottom: 15px;">
                                                    Të dhënat jane.
                                                </h3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 0 0 20px 0;">
                                                <p style="font-size: 18px; line-height: 27px; margin-bottom: 10px">
                                                    <strong>Universiteti: </strong>
                                                    ${model.state.service.university.name}
                                                </p>
                                                <p style="font-size: 18px; line-height: 27px; margin-bottom: 10px">
                                                    <strong>Fakulteti: </strong>
                                                    ${model.state.service.faculty.name}
                                                </p>
                                                <p style="font-size: 18px; line-height: 27px; margin-bottom: 10px">
                                                    <strong>Emri: </strong>
                                                    ${emailData.firstName}
                                                </p>
                                                <p style="font-size: 18px; line-height: 27px; margin-bottom: 10px">
                                                    <strong>Mbiemri: </strong>
                                                    ${emailData.lastName}
                                                </p>
                                                <p style="font-size: 18px; line-height: 27px; margin-bottom: 10px">
                                                    <strong>Pozicioni: </strong>
                                                    ${emailData.positions}
                                                </p>
                                                <p style="font-size: 18px; line-height: 27px; margin-bottom: 10px">
                                                    <strong>Adresa: </strong>
                                                    ${emailData.email}
                                                </p>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td align="center" style="padding:36px 30px 42px 30px; background: #4e4e4e">
                                    <a href="https://rash.al/sq/"
                                       target="_blank"
                                       style="font-size: 16px; color: #ffffff; text-decoration: none">
                                        RASH - Website
                                    </a>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
            </body>
            </html>
    `

    // Email.send({
    //     Host : "smtp.office365.com",
    //     Username : "no-reply@rash.al",
    //     Password : "zp@45tw2NrLFh+?",
    //     To : ['lqerraxhija@rash.al', 'lqerraxhija@gmail.com', 'ludvig_qerraxhija@yahoo.com', 'kmali@rash.al', 'djorgo@rash.al'],
    //     From : "no-reply@rash.al",
    //     Subject : "PROVE, SOFTWARE CATALOG WEBSITE, GEANT - RASH",
    //     Body : markup
    // }).then(
    //     message => {
    //         registerView.renderSuccess();
    //     }
    // );

    setTimeout(function () {
        registerView.renderSuccess();
    }, 1000);
};


const init = function () {
    controlRouting();

    // SHAME CODE.
    // I need to do this because I don't know how add an image directly from css with parcel.
    // And I'm having problem when I add it as an inline style from html.
    // This happen when I have loaded the serviceView and changed the url. When
    // the page reload then the background image isn't loaded correctly.
    // Looks like the request is made http://localhost:1234/apliko/backgroundImage instant of
    // http://localhost:1234/backgroundImage
    document.querySelector('body').style.backgroundImage = `url(${backgroundImage})`;
};

init();
